import React, { useContext, useState } from 'react'
import { ConfirmDialog } from 'components'
import { I18nContext } from 'i18n'
import { StyledCancelButton, Times } from './style'
import { Link as A } from 'raviger'

const LeaveConfirmationButton = (props) => {
  const {
    children,
    requireConfirmation = false,
    onClick: onConfirm,
    title = 'Are you sure you want to cancel?',
    subtitle = 'If you cancel you will lose any changes that you have made.',
    variant = 'secondary',
    type = 'Button',
    ...rest
  } = props
  const { translate } = useContext(I18nContext)
  const [showConfirm, setShowConfirm] = useState()

  const handleSelection = (confirmed) => {
    setShowConfirm(false)
    confirmed && onConfirm()
  }

  const handleClick = (e) => {
    e.preventDefault()
    requireConfirmation ? setShowConfirm(true) : onConfirm()
  }

  const renderActionComponent = () => {
    switch (type) {
      case 'Link':
        return (
          <A href="" onClick={handleClick} {...rest}>
            {children || translate('scholarship_copy_cancel')}
          </A>
        )
      case 'Icon':
        return (
          <Times onClick={handleClick} />
        )
      default:
        return (
          <StyledCancelButton variant={variant} onClick={handleClick} {...rest}>
            {children || (
              <>
                <Times />
                <span>{rest?.text}</span>
              </>
            )}
          </StyledCancelButton>
        )
    }
  }

  return (
    <>
      {renderActionComponent()}
      <ConfirmDialog
        show={showConfirm}
        onConfirm={handleSelection.bind(null, true)}
        onCancel={handleSelection.bind(null, false)}
        body={subtitle}
        {...{ title }}
      />
    </>
  )
}

export default LeaveConfirmationButton
